import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ClearIcon from '@mui/icons-material/Clear';
import i18n from '../../../i18n';

const SingleSelect = ({ selectedItem, items, handleChange, label, trKey, helperText, disabled }) => {
    function filterUniqueElements(arr) {
        return arr.filter((item, index) => arr.indexOf(item) === index);
    }
    const handleSelectionChange = (event, newValue) => {
        if (newValue) {
            handleChange([newValue]);
        } else {
            handleChange([]);
        }
    };
    const translateOption = (option, translateKey) => {
        if (translateKey) {
            return i18n.t(`${translateKey}.${option}`);
        }
        return option;
    };

    return (
        <Autocomplete
            value={selectedItem || null}
            disabled={disabled}
            onChange={handleSelectionChange}
            options={filterUniqueElements(items)}
            getOptionLabel={(option) => translateOption(option, trKey)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    helperText={helperText}
                />
            )}
            clearIcon={<ClearIcon />}
            clearOnEscape
            isOptionEqualToValue={(option, value) => {
                return option === value;
            }}
            sx={{
                '& .MuiInputBase-root': {
                    cursor: disabled && 'text',
                    backgroundColor: disabled
                        ? '#fafafa'
                        : 'inherit'
                },
            }}
        />
    );
};

export default SingleSelect;
